<template>
  <button
    :title="title!"
    class="rounded-full p-[11px] flex items-center justify-center active:bg-primary"
    data-test="session-button"
    :class="light ? 'bg-white!' : isActive ? 'bg-primary-hover hover:bg-primary-at-8' : 'bg-rackley-shades-300 hover:bg-rackley-shades-400'"
  >
    <span class="sr-only select-none">{{ title }}</span>
    <wui-icon
      :name="iconName"
      class="w-[18px]! h-[18px]!"
      :class="isActive ? 'text-white!' : light ? 'text-black-400' : 'text-black-200'"
    />
  </button>
</template>

<script lang="ts" setup>
import { WuiIcon, IconName } from '@wui/common-library'

defineProps<{
  title?: string,
  isActive?: boolean,
  iconName: IconName,
  disabled?: boolean
  light?: boolean
}>()
</script>
